import { createEffect } from 'solid-js'
import type { Camera } from 'three'
import { Vector3 } from 'three'
import { MapControls } from 'three/addons/controls/MapControls.js'
import useGridWidthHeight from '../../../rx/memo/useGridWidthHeight'
import { useIsEngineModeMapEditorMemo } from '../../../rx/memo/useIsEngineModeMapEditorMemo'
import { Engine } from '../../core/engine/Engine.type'
import { SET_CAMERA_DEFAULT_POLAR_ANGLE_TOP_DOWN } from '../../core/ui/action/SetCameraPolarAngleTopDown'
import { HALF_PI } from '../../core/util/math/Math'
import { VERTICES_PER_TILE } from '../consts'
import setMapControlsPolarAngle from './setMapControlsPolarAngle'

const ABSOLUTE_MIN_DISTANCE = 25 * (VERTICES_PER_TILE / 32)
const DEFAULT_MAX_DISTANCE = 400 * (VERTICES_PER_TILE / 32)


export default function createThreeMapControls(
  engine: Engine,
  elem: HTMLElement,
  camera: Camera
): MapControls {
  const getGridSize = useGridWidthHeight(engine)
  const isEngineModeMapEditor = useIsEngineModeMapEditorMemo(engine)

  const controls = new MapControls(camera, elem)

  // call this only in static scenes (i.e., if there is no animation loop)
  //controls.addEventListener( 'change', render )

  // an animation loop is required when either damping or auto-rotation are enabled
  // controls.enableDamping = true
  // controls.dampingFactor = 0.01

  // controls.mouseButtons = {
  //   LEFT: THREE.MOUSE.PAN,
  //   MIDDLE: THREE.MOUSE.DOLLY,
  //   RIGHT: THREE.MOUSE.ROTATE
  // }

  // controls.screenSpacePanning = false

  controls.minDistance = ABSOLUTE_MIN_DISTANCE
  controls.maxDistance = DEFAULT_MAX_DISTANCE
  // console.log('maxDistance.default', DEFAULT_MAX_DISTANCE)
  if (isEngineModeMapEditor()) {
    createEffect(() => {
      const { clientWidth, clientHeight } = elem
      const { width: gridWidth, height: gridHeight } = getGridSize()
      // console.log('Grid size:', gridWidth, gridHeight)
      // Update controls based on engine state if needed

      setTimeout(() => {
        const biggestDim = Math.max(
          clientWidth / (gridWidth * (VERTICES_PER_TILE / 32) ),
          clientHeight / (gridHeight * (VERTICES_PER_TILE / 32) ))
        const newMaxDistance = biggestDim * 0.5
        if (controls.maxDistance !== newMaxDistance) {
          // const oldMaxDistance = controls.maxDistance;
          controls.maxDistance = newMaxDistance
          // console.log('maxDistance', oldMaxDistance, '->', newMaxDistance, 'for grid', gridWidth, 'x', gridHeight)
          const centerOfMap = new Vector3((gridWidth * VERTICES_PER_TILE), 0, (gridHeight * VERTICES_PER_TILE) / 2)
          // centerOfMap.x = 0
          camera.position.copy(centerOfMap)
          camera.position.y += 2000
          setMapControlsPolarAngle(controls, SET_CAMERA_DEFAULT_POLAR_ANGLE_TOP_DOWN)
          camera.userData.targetHeading = 0
          camera.userData.heading = -1/100 // set to a different value to detect that the camera needs to rotate
        }
      }, 500)
    })
    // createMountedInverval(() => {
    //   console.log('controls.getDistance()', controls.getDistance(), camera.position.clone().round().toArray());
    // }, 2000)
  }

  // allow top-down viewing angle
  controls.minPolarAngle = 0

  // prevent moving camera below floor
  controls.maxPolarAngle = (0.9) * (HALF_PI)
  controls.maxPolarAngle = (HALF_PI)

  controls.zoomToCursor = true
  // controls.screenSpacePanning = true
  // controls.update()

  // controls.listenToKeyEvents(window)

  // controls.autoRotate = false

  // controls.keyPanSpeed = 50
  // controls.panSpeed = 50

  // controls.addEventListener('change', () => {
  //   // console.log('camera rotation', toFixed1(camera.rotation.x), toFixed1(camera.rotation.y), toFixed1(camera.rotation.z))
  //   console.log('camera position', toFixed1(camera.position.x), toFixed1(camera.position.y), toFixed1(camera.position.z))
  //   console.log('controls.getPolarAngle()', toFixed1(controls.getPolarAngle()))
  // })

  // setMapControlsPolarAngle(controls, 8)
  // setMapControlsPolarAngle(controls, PI * (1/4))

  return controls
}


